import React from 'react';
import PropTypes from 'prop-types';
import { Box, ShadowBox, Checkbox } from '@components/common';
import TableCell from '@components/TableCell';
import { TIME_FRAME, TIME_FRAME_TITLES } from '@services/minte';

function TimeWindow(props) {
  const { noShadow, value, availableWindow, onChange, ...restProps } = props;

  const timeframes = (availableWindow || []).map(item => ({
    value: item,
    title: TIME_FRAME_TITLES[item]
  }));

  const handleOnChange = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    onChange(value);
  };

  const renderContent = () => {
    let wrapperProps;

    if (noShadow) {
      wrapperProps = {
        pr: 0,
        ml: 0,
        boxShadow: 'none'
      };
    }

    return timeframes.map(item => {
      const { value: itemValue, title } = item;
      return (
        <TableCell
          key={itemValue}
          leftIcon={itemValue}
          leftIconColor="gold"
          title={title}
          {...wrapperProps}
          renderAccessories={() => {
            return (
              <Box ml={1}>
                <label>
                  <Checkbox
                    checked={value === itemValue}
                    mb={0}
                    variant="radio"
                    onChange={e => {
                      handleOnChange(e, itemValue);
                    }}
                  />
                </label>
              </Box>
            );
          }}
        />
      );
    });
  };

  if (noShadow) {
    return (
      <Box zIndex={999} {...restProps}>
        {renderContent()}
      </Box>
    );
  }
  return <ShadowBox {...restProps}>{renderContent()}</ShadowBox>;
}

TimeWindow.propTypes = {
  value: PropTypes.string,
  availableWindow: PropTypes.array,
  onChange: PropTypes.func,
  noShadow: PropTypes.bool
};

TimeWindow.defaultProps = {
  noShadow: false,
  availableWindow: [
    TIME_FRAME.ANYTIME,
    TIME_FRAME.MORNING,
    TIME_FRAME.AFTERNOON
  ]
};

export default TimeWindow;
